<template>
    <div>
        <div class="mb-2">
            <label class="form-label small">Tipo</label>
            <div class="form-control form-control-sm bg-light text-muted">
                {{ fieldTypeLabel }}
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-6">
                <label class="form-label small">Font Size</label>
                <input class="form-control form-control-sm" type="number" v-model.number="item.fontSize" />
            </div>
            <div class="col-6">
                <label class="form-label small">Colore</label>
                <input class="form-control form-control-sm" type="color" v-model="item.color" />
            </div>
        </div>
        <div class="mb-2">
            <label class="form-label small">Font Family</label>
            <select class="form-select form-select-sm" v-model="item.fontFamily">
                <option>Arial</option>
                <option>Times New Roman</option>
                <option>Courier New</option>
                <option>Verdana</option>
                <option>Georgia</option>
                <option>Helvetica</option>
            </select>
        </div>
        <div class="mb-2">
            <label class="form-label small">Font Weight</label>
            <select class="form-select form-select-sm" v-model="item.fontWeight">
                <option value="normal">Normal</option>
                <option value="bold">Bold</option>
                <option value="100">100</option>
                <option value="300">300</option>
                <option value="500">500</option>
                <option value="700">700</option>
                <option value="900">900</option>
            </select>
        </div>
        <div class="mb-2">
            <label class="form-label small">Allineamento</label>
            <select class="form-select form-select-sm" v-model="item.textAlign">
                <option value="left">Sinistra</option>
                <option value="center">Centro</option>
                <option value="right">Destra</option>
            </select>
        </div>
        <div class="row mb-2">
            <div class="col-6">
                <label class="form-label small">Larghezza (cm)</label>
                <input class="form-control form-control-sm" type="number" step="0.01" min="0" v-model.number="tempWidth" />
            </div>
            <div class="col-6">
                <label class="form-label small">Altezza (cm)</label>
                <input class="form-control form-control-sm" type="number" step="0.01" min="0" v-model.number="tempHeight" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import { pxToCm, cmToPx } from '@/utils/units';

@Options({})
export default class QrFieldComponentEditor extends Vue {
    @Prop() item: OM.QrFieldComponent;

    localTempWidth: number = null;
    localTempHeight: number = null;

    get fieldTypeLabel() {
        if (this.item.fieldType === 'name') return 'Nome QR';
        if (this.item.fieldType === 'description') return 'Descrizione QR';
        return 'Info QR';
    }

    @Watch('item')
    onItemChange() {
        this.localTempWidth = null;
        this.localTempHeight = null;
    }

    get tempWidth() { return this.localTempWidth ?? pxToCm(this.item.width); }
    set tempWidth(value: number) { this.localTempWidth = value; this.item.width = cmToPx(value); }

    get tempHeight() { return this.localTempHeight ?? pxToCm(this.item.height); }
    set tempHeight(value: number) { this.localTempHeight = value; this.item.height = cmToPx(value); }
}
</script>
